module.exports = __webpack_public_path__ + "static/img/pic_post_video.ce011188.png";